import React, { useState, useEffect } from 'react'
import Card from 'react-bootstrap/Card'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ReactSwitch from 'react-switch'
import axios from 'axios'
import Swal from 'sweetalert2'
import { apiRequest } from '../../store/allApi';
import Cookies from 'js-cookie';



const Gateway = () => {

//////////URL//////////////

  const [checkedUpiGateway, setUpiGateway] = useState(true)
  const [RazorDeposit, setRazorDeposit] = useState(true)
  const [upigatewayMin, setUpiGatewayMin] = useState('')
  const [upigatewayMax, setUpiGatewayMax] = useState('')
  const [gatewayMin, setGatewayMin] = useState('')
  const [gatewayMax, setGatewayMax] = useState('')
  const [whatsappRangemin, setWhatsappRangemin] = useState('')
  const [whatsappnumber, setWhatsappnumber] = useState('')
  const [whatsappRangemax, setWhatsappRangemax] = useState('')
  const [whatsappDeposit, setWhatsappDeposit] = useState(true)
  const [imbupiGateway2, setimbupiGateway2] = useState(true)
  const [imbLimitMin2, SetimbLimitMin2] = useState(10)
  const [imbLimitMax2, SetimbLimitMax2] = useState(10)


  // console.log(enable_otp)
  const beckendLocalApiUrl = process.env.REACT_APP_API_BASE_URL
  const beckendLiveApiUrl = process.env.REACT_APP_API_BASE_URL
  const nodeMode = process.env.NODE_ENV
  if (nodeMode === 'development') {
    var baseUrl = beckendLocalApiUrl
  } else {
    baseUrl = beckendLiveApiUrl
  }
  
  const handleChangeUpi6 = val => {
    setimbupiGateway2(val)
  }
  const handleChangeUpi = val => {
    setUpiGateway(val)
  }
  const handleChangeGateway = val => {
    setRazorDeposit(val)
  }

  const handleChangeWhatsapp = val => {
    setWhatsappDeposit(val)
  }

 

   const SiteData =async () => {
          const access_token =  Cookies.get('token') || localStorage.getItem("token")
          const headers = {
            Authorization: `Bearer ${access_token}`
          }
         
          try {
                const res = await apiRequest(`gatewaysettings/data`,"GET", null,headers)
                if (res.data) {
                setRazorDeposit(res.data.RazorDeposit)              
                setUpiGateway(res.data.isUpiGateway)
                setUpiGatewayMin(res.data.upigatewayMin)
                setUpiGatewayMax(res.data.upigatewayMax)
                setGatewayMin(res.data.gatewayMin)
                setGatewayMax(res.data.gatewayMax)
                setWhatsappRangemin(res.data.whatsappRangemin)
                setWhatsappRangemax(res.data.whatsappRangemax)
                setWhatsappnumber(res.data.whatsappnumber)
                setWhatsappDeposit(res.data.whatsappDeposit)
                setimbupiGateway2(res.data.imbupiGateway2)
                SetimbLimitMin2(res.data.imbLimitMin2)
                SetimbLimitMax2(res.data.imbLimitMax2)
                }
                  } catch (e) {
                    // setLoading(false)                       
                  }
                  finally {
                 }
          }
  
  useEffect(() => {
    SiteData()
  }, []);

  const handleSubmit1 = async (e) => {
  e.preventDefault();
  const access_token = localStorage.getItem('token');
  if (!access_token) return alert('Not authenticated');

  const headers = {
    Authorization: `Bearer ${access_token}`,
    'Content-Type': 'application/json'
  };

  try {
    const res = await apiRequest(
      'gatewaysettings',
      'POST',
      {
        checkedUpiGateway,
        upigatewayMin,
        upigatewayMax,
        gatewayMin,
        gatewayMax,
        RazorDeposit,
        whatsappRangemin,
        whatsappRangemax,
        whatsappnumber,
        whatsappDeposit,
        imbLimitMin2,
        imbLimitMax2,
        imbupiGateway2
      },
      headers
    );

    if (res?.data?.status === 'success') {
      alert('Settings submitted successfully');
    } else {
      alert('Settings Not Submitted');
    }
  } catch (err) {
    console.error(err);
    alert('Request failed');
  }
};




 
 



  return (
    <>
      <div className='card mt-5'>
        <div className='card-body  table_bg'>
          <h4 className='dashboard_heading my-3'>Payment Gateway Settings</h4>

          {/* <h4 className='my-3 dashboard_small_heading_dark'>Pay In Or Pay Out</h4> */}
           

          {/* <h5 className='dashboard_small_heading_dark my-3'>RazorPay</h5> */}

          <form
            action='gatewaysettings'
            className='form'
            onSubmit={handleSubmit1}
            method='patch'
            enctype='multipart/form-date'
          >

    <div className='form-row'>          
            <div className='form-group col-md-6'>
                <Card>
                  <Card.Body>
                    <h4 className='dashboard_small_heading_blue'>
                      Gateway
                    </h4>
                    <Container>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Upi Gateway</Col>
                        <Col sm={2}>
                          {' '}
                          <ReactSwitch
                            checked={checkedUpiGateway}
                            onChange={handleChangeUpi}
                            style={{ display: 'none' }}
                          />
                        </Col>
                      </Row>
                      
                      <Row style={{ marginRight: '4.25rem', marginTop: '10px' }} >
                        <Col sm={6}>Upi Limit Min</Col>
                        <Col sm={1}>
                          <input
                            type='number'
                            value={upigatewayMin}
                            onChange={e => setUpiGatewayMin(e.target.value)}
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            placeholder='Withdrawa Limit Min'
                          />
                        </Col>
                      </Row>
                        <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Upi Limit Max</Col>
                        <Col sm={1}>
                          <input
                            type='number'
                            value={upigatewayMax}
                            onChange={e => setUpiGatewayMax(e.target.value)}
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            placeholder='Withdrawa Limit Min'
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Digital Items</Col>
                        <Col sm={2}>
                          {' '}
                          <ReactSwitch
                            checked={RazorDeposit}
                            onChange={handleChangeGateway}
                            style={{ display: 'none' }}
                          />
                        </Col>
                      </Row>
                        <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Deposit Limit Min</Col>
                        <Col sm={1}>
                          <input
                            type='number'
                            value={gatewayMin}
                            onChange={e => setGatewayMin(e.target.value)}
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            placeholder='Withdrawa Limit Min'
                          />
                        </Col>
                      </Row>
                        <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Deposit Limit Max</Col>
                        <Col sm={1}>
                          <input
                            type='number'
                            value={gatewayMax}
                            onChange={e => setGatewayMax(e.target.value)}
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            placeholder='Withdrawa Limit Min'
                          />
                        </Col>
                      </Row>


                      
                     <Row
                          style={{ marginRight: '4.25rem', marginTop: '10px' }}
                        >
                          <Col sm={6}>Whatsapp Deposit</Col>
                          <Col sm={2}>
                            {' '}
                            <ReactSwitch
                              checked={whatsappDeposit}
                              onChange={handleChangeWhatsapp}
                              style={{ display: 'none' }}
                            />
                          </Col>
                        </Row> 

                        <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Whatsapp Number</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={whatsappnumber}
                            onChange={e => setWhatsappnumber(e.target.value)}
                            placeholder='Enter Whatsapp Number'
                          />
                        </Col>
                      </Row>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>Range-Min</Col>
                        <Col sm={1}>
                          <input
                            type='text'
                            style={{
                              border: '1px Solid Black',
                              borderRadius: '3px'
                            }}
                            value={whatsappRangemin}
                            onChange={e => setWhatsappRangemin(e.target.value)}
                            placeholder='Enter Range Max'
                          />
                        </Col>
                      </Row>

                      <Row
                          style={{ marginRight: '4.25rem', marginTop: '10px' }}
                        >
                          <Col sm={6}>Range-Max</Col>
                          <Col sm={1}>
                            <input
                              type='text'
                              style={{
                                border: '1px Solid Black',
                                borderRadius: '3px'
                              }}
                              value={whatsappRangemax}
                              onChange={e => setWhatsappRangemax(e.target.value)}
                              placeholder='Enter Range Max'
                            />
                          </Col>
                        </Row> 

                        <Row style={{ marginRight: '4.25rem', marginTop: '10px' }}>
                        <Col sm={6}>IMB Gateway </Col>
                          <Col sm={2}>
                            {' '}
                            <ReactSwitch
                              checked={imbupiGateway2}
                              onChange={handleChangeUpi6}
                              style={{ display: 'none' }}
                            />
                          </Col></Row>
                           <Row style={{ marginRight: '4.25rem', marginTop: '10px' }}>
                             <Col sm={6}>IMB Limit-Min</Col>
                          <Col sm={1}>
                          <input type='number' name=''  value={imbLimitMin2}                             onChange={e =>
                                SetimbLimitMin2(e.target.value)
                              }
                              style={{
                                border: '1px solid black',
                                borderRadius: '3px'
                              }}
                              placeholder='Enter UPI Limit'
                            />
                          </Col>
                        </Row>

                        
                        <Row style={{ marginRight: '4.25rem', marginTop: '10px' }}>
                          <Col sm={6}>IMB Limit-Max</Col>
                              <Col sm={1}>
                              <input
                                  type='number'
                                  name=''
                                  value={imbLimitMax2}
                                  onChange={e =>
                                    SetimbLimitMax2(e.target.value)
                                  }
                                  style={{
                                    border: '1px solid black',
                                    borderRadius: '3px'
                                  }}
                                  placeholder='Enter UPI Limit'
                                />
                              </Col>
                        </Row>
                      <Row
                        style={{ marginRight: '4.25rem', marginTop: '10px' }}
                      >
                        <Col sm={6}>
                          <button type='submit' className='btn btn-dark'>
                            submit
                          </button>
                        </Col>
                      </Row>


                    </Container>
                  </Card.Body>
                </Card>
              </div>

              
       
          
            
             
          
            </div>

          </form>
     
        
        </div>
      </div>
    </>
  )
}

export default Gateway
